module.exports = __webpack_public_path__ + "static/performance-ignition-systems-3a38c0a884f5a5b8a432af34b95b4d52.jpg";